import { Loader } from "@googlemaps/js-api-loader";

const loader = new Loader({
    apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    version: "weekly",
    libraries: ["places", "drawing"],
});

let googlePromise = null;

export const loadGoogleMaps = () => {
    if (!googlePromise) {
        googlePromise = loader.load();
    }

    return googlePromise;
};